import { ReactNode } from 'react'

import { QuickTip } from 'govwell-ui'
import { ViewColumnTemplateFragment, ViewColumnType } from 'types/graphql'

type TableViewColumnOverride = {
  renderHeader?: (args: {
    columnTemplate: ViewColumnTemplateFragment
    defaultHeader: ReactNode
  }) => ReactNode
}

const PAID_BY_TOOLTIP = (
  <>
    The person who paid the invoice or fee.
    <br />
    <br />
    <i>(e.g. the applicant or a third party paying on their behalf)</i>
  </>
)
const PROCESSED_BY_TOOLTIP = (
  <>
    The user who entered the payment in GovWell.
    <br />
    <br />
    <i>
      (e.g. the applicant paying online, or the staff member who recorded a cash/check or processed
      a card payment)
    </i>
  </>
)

const ESTIMATED_BANK_DEPOSIT_DATE_TOOLTIP = (
  <> This is an estimated date based on processing times and may vary. </>
)

const headerWithTooltip = (defaultHeader: ReactNode, tooltip: ReactNode): ReactNode => (
  <>
    {defaultHeader}
    <QuickTip content={tooltip} />
  </>
)

export const TableViewColumnOverrides: Partial<Record<ViewColumnType, TableViewColumnOverride>> = {
  RecordTaskPaymentPaidBy: {
    renderHeader: ({ defaultHeader }) => headerWithTooltip(defaultHeader, PAID_BY_TOOLTIP),
  },
  RecordTaskPaymentProcessedBy: {
    renderHeader: ({ defaultHeader }) => headerWithTooltip(defaultHeader, PROCESSED_BY_TOOLTIP),
  },
  SettlementEstimatedBankDepositDate: {
    renderHeader: ({ defaultHeader }) =>
      headerWithTooltip(defaultHeader, ESTIMATED_BANK_DEPOSIT_DATE_TOOLTIP),
  },
}
